import { getI18n, ROUTES } from "@editor/ui-utils";
const de = {
  staticPageApi: {
    createAlreadyExists: "Statische Seite kann nicht erstellt werden, da bereits ein statische Seite mit diesem Namen existiert",
    updateAlreadyExists: "Statische Seite kann nicht aktualisiert werden, da bereits ein statische Seite mit diesem Namen existiert",
    created: "Statische Seite erstellt",
    updated: "Statische Seite aktualisiert",
    notFound: "Statische Seite nicht gefunden",
    requiredFields: "Sie können den statische Seite nicht speichern, da obligatorische Informationen fehlen"
  },
  staticPageList: {
    newButton: "Neue statische Seite",
    name: "Nach Titel suchen",
    deleteStaticPage: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade statische Seite",
    headerTitle: "Bezeichnung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createStaticPage: "StaticPage erstellen",
    goToStaticPage: "Zum Artikel"
  },
  staticPage: {
    staticPageLabel: "Statische Seite",
    backButton: "Zurück zur Liste der statischen Seiten",
    saveAndPublishButton: "Speichern & Veröffentlichen",
    newStaticPage: "Neue statische Seite",
    messageDeleteStaticPage: "StaticPage löschen",
    messageDeleteStaticPageTitle: "Sind Sie sicher, dass Sie dieses statische Seite löschen möchten?",
    deleteStaticPage: "Löschen",
    messageDeleted: "StaticPage gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des statische Seite",
    errorFailedLoadedStaticPageWithId: "Es gab einen Fehler beim Abrufen des statische Seite",
    saveOffline: "Artikel offline nehmen",
    messageConfirmTakeOffline: "Bist du sicher, dass du den Artikel offline nehmen möchtest?"
  },
  staticPageEdit: {
    basicsTab: "Basics",
    contentTab: "Inhalt",
    codeContentTab: "Code-Inhalt",
    title: "Titel",
    slug: "URL-Slug",
    seoTitle: "SEO-Titel",
    seoDescription: "SEO-Beschreibung",
    isConsentRequired: "CMP aktiviert",
    content: "Inhalt",
    codeContent: "Code-Inhalt",
    goToPage: "Zur Seite gehen",
    backButton: "Zurück zur Liste der statischen Seiten",
    editStaticPage: "Statische Seite bearbeiten",
    messageSaved: "Neue statische Seite gespeichert",
    messageUpdated: "Statische Seite aktualisiert",
    showTitle: "Titel anzeigen"
  }
};
const en = {
  staticPageApi: {
    createAlreadyExists: "Can't create Static Page because another Static Page with this name already exists",
    updateAlreadyExists: "Can't update Static Page because another Static Page with this name already exists",
    created: "Static Page created",
    updated: "Static Page updated",
    notFound: "Static Page not found",
    requiredFields: "You can't save the Static Page because mandatory information is missing"
  },
  staticPageList: {
    newButton: "New Static Page",
    name: "Search by title",
    deleteStaticPage: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Static Page",
    headerTitle: "Title",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createStaticPage: "Create Static Page",
    goToStaticPage: "Go to Article"
  },
  staticPage: {
    staticPageLabel: "Static Page",
    backButton: "Back to Static Pages list",
    saveAndPublishButton: "Save & Publish",
    newStaticPage: "New Static Page",
    messageDeleteStaticPage: "Delete Static Page",
    messageDeleteStaticPageTitle: "Are you sure you want to delete this Static Page?",
    deleteStaticPage: "Delete",
    messageDeleted: "Static Page Deleted",
    errorOnDeleting: "There was an error deleting the Static Page ",
    errorFailedLoadedStaticPageWithId: "There was an error getting the Static Page",
    saveOffline: "Take offline",
    messageConfirmTakeOffline: "Are you sure you want to take this page offline?"
  },
  staticPageEdit: {
    basicsTab: "Basics",
    contentTab: "Content",
    codeContentTab: "Code Content",
    title: "Title",
    slug: "Slug",
    seoTitle: "SEO Title",
    seoDescription: "SEO Description",
    isConsentRequired: "CMP Activated",
    content: "Content",
    codeContent: "Code Content",
    goToPage: "Go to page",
    backButton: "Back to Static Page list",
    editStaticPage: "Edit Static Page",
    messageSaved: "New Static Page saved",
    messageUpdated: "Static Page updated",
    showTitle: "Show Title"
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.staticPages.path}`,
    meta: { i18RouteTitleKey: ROUTES.staticPages.path },
    children: [
      {
        path: "",
        name: "static_page_list",
        component: () => import("./static-page-list.view-CY7eqJPd.js"),
        meta: { requiredRight: "navigate_list_static_page" }
      },
      {
        path: "new",
        name: "static_page_new",
        component: () => import("./static-page-edit.view-CRZI9hwX.js"),
        props: () => ({
          title: getI18n().t("staticPage.newStaticPage"),
          backRoute: "/static-page"
        }),
        meta: { requiredRight: ["navigate_static_page"] }
      },
      {
        path: ":id",
        name: "static_page_detail",
        component: () => import("./static-page-edit.view-CRZI9hwX.js"),
        props: (route) => ({
          title: getI18n().t("staticPageEdit.editStaticPage"),
          id: route.params.id,
          backRoute: "/static-page"
        }),
        meta: { requiredRight: ["navigate_static_page"] }
      }
    ]
  }
];
const staticPageModule = {
  messages,
  routes
};
export {
  staticPageModule
};
//# sourceMappingURL=index.es.js.map
